<template>
  <div class="d-flex flex-row align-items-center justify-content-center">
    <img
      :src="scrolled ? logoSmart : logo"
      alt="石川県介護支援専門員協会"
      class="logo"
      role="button"
      style="width: auto"
      :style="
        isMobile
          ? scrolled
            ? {
                'max-width': '100px',
                height: '12px',
              }
            : {
                'max-width': '200px',
                height: '28px',
              }
          : scrolled
          ? {
              'max-width': '200px',
              height: '18px',
            }
          : {
              'max-width': '300px',
              height: '40px',
            }
      "
      @click="goto({ name: 'Index' })"
    />
    <a v-if="showPhoneNumber" :href="`tel:0762241211`" class="ms-2">
      <div
        class="d-flex align-items-center"
        style="color: #b0b8bf"
        :style="{ 'font-size': isMobile ? '0.7rem' : '0.9rem' }"
      >
        <i
          class="pi pi-phone me-1"
          :style="{ 'font-size': isMobile ? '0.7rem' : '0.9rem' }"
        ></i>
        <p>事務局：076-224-1211</p>
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { useMqUtils, useRouterUtil } from "/@/vue/composables";
import logo from "../../../../../public/img/logo.gif";
import logoSmart from "../../../../../public/img/logo_smart.png";

const { isMobile } = useMqUtils();
const { goto } = useRouterUtil();

defineProps<{
  showPhoneNumber?: boolean;
  scrolled?: boolean;
}>();
</script>

<style scoped></style>
